export default __webpack_public_path__ + "static/media/bd-exec-3.64591f15.jpg";